import React, { ChangeEvent, FC, useEffect, useState, useRef } from 'react';
import { Switch } from '@mui/material';
import { OSStateData } from '@getvim/vim-connect-app';
import { ICONS_MAP, StatesProps } from '../../../types';
import { addLeadingZero, getItemId, sendSetStateConfidentFilterData } from '../../../services';
import { State } from '../state';
import { ButtonIcon } from '../common';

export const States: FC<StatesProps> = ({
  states,
  isStateConfidentFilter = false,
  onClearAllStates,
  onSetStateConfidentFilterClick,
}) => {
  const [isConfidentFilterLocal, setIsStateConfidentFilterLocal] = useState<boolean>(false);
  const stickyControlsRef = useRef<HTMLDivElement>(null);

  useEffect((): void => {
    setIsStateConfidentFilterLocal(isStateConfidentFilter);
  }, [isStateConfidentFilter]);

  useEffect(() => {
    const handleScroll = () => {
      if (stickyControlsRef.current) {
        const scrollTop = document.querySelector('.os-container')?.scrollTop || 0;
        if (scrollTop > 10) {
          stickyControlsRef.current.classList.add('scrolled');
        } else {
          stickyControlsRef.current.classList.remove('scrolled');
        }
      }
    };
    const container = document.querySelector('.os-container');
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const handleStateConfidentFilterSwitch = (e: ChangeEvent<HTMLInputElement>) => {
    onSetStateConfidentFilterClick(e.target.checked);
    setIsStateConfidentFilterLocal(e.target.checked);
    sendSetStateConfidentFilterData(e.target.checked);
  };

  const filteredStates: OSStateData[] = isConfidentFilterLocal
    ? states.filter((state: OSStateData) => state.data.confidence === 1)
    : states;
  const disabled: boolean = filteredStates.length === 0;

  return (
    <>
      <div className="sticky-controls" ref={stickyControlsRef}>
        <div className="states">
          <div className="controls-panel">
            <div className="clear-states">
              <ButtonIcon
                id="clear-all-event"
                className="button mini"
                onClick={onClearAllStates}
                disabled={disabled}
                icon={ICONS_MAP['delete']}
              />
            </div>
            <div className="confident-filter">
              <div className="label">Show confident 1 only</div>
              <div className="switcher">
                <Switch
                  checked={isConfidentFilterLocal}
                  onChange={handleStateConfidentFilterSwitch}
                  color="warning"
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-divider">States ({addLeadingZero(filteredStates.length)})</div>
      {filteredStates.map((state: OSStateData) => (
        <State key={getItemId(state.id, state.receivedDate)} state={state} />
      ))}
    </>
  );
};

States.displayName = 'States';
